"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.objectArrayToStringArray = exports.mapAttributesToMcpAttributes = exports.variableAttributesArrayToObject = exports.arrayOfStringArraysToArrayOfObjects = exports.stringArrayToObject = exports.keyValueObjectToStringArray = void 0;
const array_1 = require("./transformers/array");
Object.defineProperty(exports, "keyValueObjectToStringArray", {
  enumerable: true,
  get: function () {
    return array_1.keyValueObjectToStringArray;
  }
});
Object.defineProperty(exports, "stringArrayToObject", {
  enumerable: true,
  get: function () {
    return array_1.stringArrayToObject;
  }
});
Object.defineProperty(exports, "arrayOfStringArraysToArrayOfObjects", {
  enumerable: true,
  get: function () {
    return array_1.arrayOfStringArraysToArrayOfObjects;
  }
});
const variableAttributes_1 = require("./transformers/variableAttributes");
Object.defineProperty(exports, "variableAttributesArrayToObject", {
  enumerable: true,
  get: function () {
    return variableAttributes_1.variableAttributesArrayToObject;
  }
});
Object.defineProperty(exports, "mapAttributesToMcpAttributes", {
  enumerable: true,
  get: function () {
    return variableAttributes_1.mapAttributesToMcpAttributes;
  }
});
const object_1 = __importDefault(require("./transformers/object"));
exports.objectArrayToStringArray = object_1.default;